// fixme: falta agregar blogs, se supone que estan comentados pero falta hacerlos

import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "../Views/Login";

// vistas generales
import Index from "../Views/Index/Index";
import Directorio from "../Views/Directorio/Directorio";
import Profesores from "../Views/Profesores/Profesores";
import Calendario from "../Views/Calendario/Calendario";
import Reinscripcion from "../Views/Reinscripcion/Reinscripcion";
import Titulacion from "../Views/Titulacion/Titulacion";
import Admision from "../Views/Admision/Aspirantes";
// import Becas from '../Views/Beca/Becas';
import FAQs from "../Views/FAQs/Preguntas";

// Licenciaturas
// import LicenciaturaCine from '../Views/Licenciaturas/Cine/Cine';
// import LicenciaturaAnimacion from '../Views/Licenciaturas/Animacion/Animacion';
// import LicenciaturaMarketing from '../Views/Licenciaturas/Marketing/Marketing';
// import LicenciaturaMultimedia from '../Views/Licenciaturas/Multimedia/Multimedia';

// Solicitudes de ingreso
import SolicitudReinscripcion from "../Views/Solicitudes/Solicitud_reinscripcion/SolicitudReinscripcion";
import SolicitudRein from "../Views/Solicitudes/Solicitud/Solicitud";
import SolicitudInscripcion from "../Views/Solicitudes/Solicitud_inscripcion/SolicitudInscripcion";
import SolicitudIns from "../Views/Solicitudes/Solicitud_ins/Solicitud";

// Reinscripciones
import ArchivosReinscripcion from "../Views/AllArchivos/ArchivosReinscripcion/ArchivosReinscripcion";
import ReinscripcionDataArchivo from "../Views/AllArchivos/ArchivosReinscripcion/Archivos";
import ArchivoReinscripcion from "../Views/AllArchivos/ArchivosReinscripcion/Archivo";

// Inscripciones
import ArchivosInscripcion from "../Views/AllArchivos/ArchivosInscripcion/ArchivosInscripcion";
import InscripcionDataArchivo from "../Views/AllArchivos/ArchivosInscripcion/Archivos";
import ArchivoInscripcion from "../Views/AllArchivos/ArchivosInscripcion/Archivo";

// PDF's estudiantes
import Estudiantes from "../Views/Estudiantes/Estudiantes";
import PDF from "../Views/Estudiantes/PDF/PDF";
import AgregarPdf from "../Views/AgregarPdf/AgregarPdf";

// administradores
import Administradores from "../Views/Administradores/Administradores";
import EditarAdministrador from "../Views/Administradores/EditarAdministrador";
import AgregarAdministrador from "../Views/Administradores/AgregarAdmin";

// cursos
import CursosGeneral from "../Views/Cursos/General";
import Cursos from "../Views/Cursos/Cursos";
import Curso from "../Views/Cursos/Curso/Curso";
import Etiquetas from "../Views/Etiquetas/Etiquetas";
import ProfesoresCursos from "../Views/ProfesoresCursos/ProfesoresCursos";

// autores blogs
import AutoresBlogs from "../Views/AutoresBlogs/AutoresBlogs";

// blogs
import Blogs from "../Views/Blogs/Blogs";
import Blog from "../Views/Blogs/Blog/Blog";
import EtiquetasBlogs from "../Views/EtiquetasBlogs/Etiquetas";

// baners
import Baners from "../Views/Baners/Baner";

// nuevos módulos
import Noticias from "../Views/Noticias/Noticias";
import Mensajes from "../Views/Mensajes/Mensajes";
import Pop from "../Views/Pop/Pop";

const RouterFunction = () => {
  return (
    <BrowserRouter>
      <div id="loader_padre" />
      <Routes>
        <Route path="/" element={<Login />} />

        {/* vistas */}
        <Route path="/index" element={<Index />} />
        <Route path="/directorio" element={<Directorio />} />
        <Route path="/profesores" element={<Profesores />} />
        <Route path="/calendario" element={<Calendario />} />
        <Route path="/reinscripcion" element={<Reinscripcion />} />
        <Route path="/titulaciones" element={<Titulacion />} />
        {/* <Route path="/becas" element={<Becas />} /> */}
        <Route path="/preguntas-frecuentes" element={<FAQs />} />
        <Route path="/proceso-admision" element={<Admision />} />

        {/* reinscripciones */}
        <Route
          path="/solicitud-reinscripciones"
          element={<SolicitudReinscripcion />}
        />
        <Route
          path="/solicitud-reinscripcion/:id"
          element={<SolicitudRein />}
        />
        <Route
          path="/solicitud-reinscripcion-archivado/:id"
          element={<SolicitudRein />}
        />
        {/* archivados */}
        <Route
          path="/archivos-reinscripciones"
          element={<ArchivosReinscripcion />}
        />
        <Route
          path="/archivos-reinscripcion/:licenciatura"
          element={<ReinscripcionDataArchivo />}
        />
        <Route
          path="/archivo-reinscripcion/:rangoFecha/:anio"
          element={<ArchivoReinscripcion />}
        />

        {/* inscripciones */}
        <Route
          path="/solicitud-inscripciones"
          element={<SolicitudInscripcion />}
        />
        <Route path="/solicitud-inscripcion/:id" element={<SolicitudIns />} />
        <Route
          path="/solicitud-inscripcion-archivado/:id"
          element={<SolicitudIns />}
        />
        {/* archivados */}
        <Route
          path="/archivos-inscripciones"
          element={<ArchivosInscripcion />}
        />
        <Route
          path="/archivos-inscripcion/:licenciatura"
          element={<InscripcionDataArchivo />}
        />
        <Route
          path="/archivo-inscripcion/:rangoFecha/:anio"
          element={<ArchivoInscripcion />}
        />

        {/* PDFs estudiantes */}
        <Route path="/estudiantes" element={<Estudiantes />} />
        <Route path="/estudiantes-pdf/:tipo" element={<PDF />} />
        <Route path="/agregar-pdf/:tipo" element={<AgregarPdf />} />

        {/* Administradores */}
        <Route path="/administradores" element={<Administradores />} />
        <Route path="/administrador/:id" element={<EditarAdministrador />} />
        <Route
          path="/administrador-agregar"
          element={<AgregarAdministrador />}
        />

        {/* blogs */}
        <Route path="/blogs-noticias" element={<Blogs />} />
        <Route path="/editar-blog/:id" element={<Blog />} />
        <Route path="/etiquetas-blogs" element={<EtiquetasBlogs />} />
        <Route path="/autores-blogs" element={<AutoresBlogs />} />

        {/* cursos */}
        <Route path="/cursos-diplomados" element={<CursosGeneral />} />
        <Route path="/profesores-cursos" element={<ProfesoresCursos />} />
        <Route path="/cursos/:tipo" element={<Cursos />} />
        <Route path="/curso/:id" element={<Curso />} />
        <Route path="/etiquetas" element={<Etiquetas />} />

        {/* baners */}
        <Route path="/baners" element={<Baners />} />

        {/* nuevos módulos */}
        <Route path="/noticias" element={<Noticias />} />
        <Route path="/mensajes" element={<Mensajes />} />
        <Route path="/pop" element={<Pop />} />

        {/* <Route path="/licenciaturas/cine" element={<LicenciaturaCine />} /> */}
        {/* <Route path="/licenciaturas/animacion" element={<LicenciaturaAnimacion />} /> */}
        {/* <Route path="/licenciaturas/marketing" element={<LicenciaturaMarketing />} /> */}
        {/* <Route path="/licenciaturas/multimedia" element={<LicenciaturaMultimedia />} /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default RouterFunction;
